import { z } from "zod";

type ValidationPropertiesType = {
    isValid: boolean,
}

type ValidationResultType = {
    isValid: boolean
    error: string
}

export function useValidationZod<
    Data extends Record<string, any>,
    Validation extends Omit<Data, 'set' | 'reset' | 'update' | 'handleChange' | 'toObject'>,
    Config extends Partial<Record<keyof Validation, z.ZodType>>,
>(data: Data, config: (zod: typeof z) => Config): ValidationPropertiesType & Record<keyof Config, ValidationResultType> {
    const result: ValidationPropertiesType & Record<string, any> = {
        isValid: true,
    };

    const rules = config(z);

    for (const key in rules) {
        const value = data[key];
        const rule = rules[key] as z.ZodType;
        const validationResult: ValidationResultType = {
            isValid: true,
            error: ''
        }

        try {
            rule.parse(value);
        } catch (error) {
            if (error instanceof z.ZodError) {
                if (error.issues.length > 0) {
                    validationResult.error = error.issues[0].message;
                    validationResult.isValid = false;
                    result.isValid = false;
                }
            }
        }

        result[key] = validationResult;
    }

    return result as ValidationPropertiesType & Record<keyof Config, ValidationResultType>;
}
